import { createApiError } from "@/utils";

export async function requestApi(url, options) {
  const response = await fetch(url, options);
  if (!response.ok) {
    let body;
    try {
      body = await response.json();
    } catch {
      // Proxies may return HTML or an empty body instead of an API error.
      body = null;
    }
    throw createApiError(
      response.status,
      body,
      response.headers.get("X-Error-Code")
    );
  }
  if (["PATCH", "DELETE"].includes(options.method)) return;
  return (await response.json()).result;
}
